import gql from 'graphql-tag';
import {get, isEmpty} from 'lodash';
import {useQuery} from '@apollo/react-hooks';

const POPULAR_FILTER_ID = '13';
const amenityCarouselSearchQuery = gql`
    query($request: SearchResultRequest!, $popularFilters: [String]!) {
        popularAmenitySearch(
            request: $request
            popularFilters: $popularFilters
        ) {
            searchResult {
                listings {
                    averageRating
                    bedrooms
                    detailPageUrl
                    listingId
                    propertyMetadata {
                        headline
                    }
                    headlinePhoto {
                        uri
                    }
                    photos {
                        uri
                    }
                    sleeps
                    averagePrice {
                        value
                    }
                    priceSummary {
                        formattedAmount
                        pricePeriodDescription
                    }
                    spaces {
                        bathrooms {
                            capacity
                        }
                    }
                    reviewCount
                }
            }
            title
            chosenFilter
        }
    }
`;

export const useFetchAmenityCarouselListings = (
    searchParams,
    isMobile,
    parsedParams,
    results,
    showMabCarousels = true
) => {
    const popularFilters = results.filterGroups.find(
        (item) => item.groupInfo.id === POPULAR_FILTER_ID
    ) || {filters: []};

    const {data, loading} = useQuery(amenityCarouselSearchQuery, {
        skip: !showMabCarousels,
        errorPolicy: 'ignore',
        variables: {
            request: {
                ...parsedParams,
                paging: {
                    page: 1,
                    pageSize: 10
                }
            },
            popularFilters: popularFilters.filters.reduce(
                (acc, value) => [...acc, value.filter.refineByQueryArgument],
                []
            )
        }
    });

    const listings = get(
        data,
        ['popularAmenitySearch', 'searchResult', 'listings'],
        []
    );

    return {
        amenityCarouselData: isEmpty(listings) ? null : data,
        amenityCarouselDataLoading: loading
    };
};
